import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { styled } from "@mui/material";
import { AddButton, BracketButton, Button0, Button1, Button2, Button3, Button4, Button5, Button6, Button7, Button8, Button9, ClearButton, DivButton, EqualButton, EraseButton, FavoriteButton, FunButton, HistoryButton, LeftButton, MemoryButton, MulButton, PercentButton, PointButton, RightButton, SubButton, VarButton } from "./CalculatorButtons";
const RootGrid = styled("div")({
    display: "grid",
    gridTemplateRows: "2fr 1fr 3fr",
    gridTemplateColumns: "1fr",
    width: "100%",
    height: "100%",
});
const PartialGrid = styled("div")({
    display: "grid",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "1fr 5fr 1fr 1fr",
    minHeight: "0",
    overflowY: "hidden",
});
const KeyGrid = styled("div")({
    display: "grid",
    gridTemplateRows: "1fr 1fr 1fr",
    gridTemplateColumns: "repeat(8,1fr)",
});
const keyGridSx = {
    backgroundColor: "normalButton",
};
export default memo((props) => {
    return (_jsxs(RootGrid, { children: [props.editor, _jsxs(PartialGrid, { children: [_jsx(EqualButton, { ...props }), props.result, _jsx(EraseButton, { ...props }), _jsx(ClearButton, { ...props })] }), _jsxs(KeyGrid, { sx: keyGridSx, children: [_jsx(LeftButton, { ...props }), _jsx(RightButton, { ...props }), _jsx(Button7, { ...props }), _jsx(Button8, { ...props }), _jsx(Button9, { ...props }), _jsx(DivButton, { ...props }), _jsx(MulButton, { ...props }), _jsx(MemoryButton, { ...props }), _jsx(VarButton, { ...props }), _jsx(FunButton, { ...props }), _jsx(Button4, { ...props }), _jsx(Button5, { ...props }), _jsx(Button6, { ...props }), _jsx(SubButton, { ...props }), _jsx(AddButton, { ...props }), _jsx(HistoryButton, { ...props }), _jsx(FavoriteButton, { ...props }), _jsx(PercentButton, { ...props }), _jsx(Button1, { ...props }), _jsx(Button2, { ...props }), _jsx(Button3, { ...props }), _jsx(Button0, { ...props }), _jsx(PointButton, { ...props }), _jsx(BracketButton, { ...props })] })] }));
});
